// extracted by mini-css-extract-plugin
export default {"header":"FuwModal_header__rfu+w","close":"FuwModal_close__GR9wm"};